/**
 * Fixed evidence-summary prompt. Sent automatically by the "Get summary"
 * suggestion banner (see `useEvidenceSummarySuggestion`) and prefilled (not
 * sent) into the floating Ask Heidi input by the GRO-3269 "Improve your
 * notes" Ask Heidi spotlight.
 *
 * Lives in its own module so consumers can import the constant without
 * pulling the banner hook's dependency graph.
 */
export const EVIDENCE_SUMMARY_PROMPT =
  'Based on the clinical note for this session, identify any evidence-based guidelines, drug interactions, red flags, or management considerations from my sources that are relevant to the presenting conditions and current medications.';
